import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button } from '@components/Button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@components/Card';
import { AnonymousHeader } from '@components/layout/AnonymousHeader';
import { AnonymousFooter } from '@components/layout/AnonymousFooter';
import { useAuth } from './useAuth';

const SignOut: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { logout } = useAuth();

  const handleConfirmSignOut = () => {
    // Clear authentication state and redirect to login
    logout();
    navigate('/login');
  };

  const handleCancel = () => {
    // Go back to previous page or dashboard
    navigate(-1);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-primary-500 via-secondary-500 to-primary-600 flex flex-col sign-out-page">
      {/* Anonymous Header */}
      <AnonymousHeader />

      {/* Main Content */}
      <div className="flex-1 flex items-center justify-center p-4">
        <Card className="w-full max-w-md shadow-2xl">
          <CardHeader className="text-center pb-8">
            <div className="mx-auto mb-6 w-16 h-16 bg-gradient-to-r from-red-500 to-red-600 rounded-full flex items-center justify-center">
              <span className="material-icons text-2xl text-white">logout</span>
            </div>
            <CardTitle className="text-3xl font-bold text-gray-900 dark:text-white">
              {t('auth.signOut')}
            </CardTitle>
            <CardDescription className="text-lg text-gray-700 dark:text-gray-400">
              {t('auth.signOutConfirmation')}
            </CardDescription>
          </CardHeader>
          <CardContent className="px-8 pb-8">
            <div className="space-y-6">
              <div className="flex flex-col sm:flex-row gap-3">
                <Button variant="outline" onClick={handleCancel} className="flex-1" size="lg">
                  {t('common.cancel')}
                </Button>
                <Button
                  variant="outline"
                  onClick={handleConfirmSignOut}
                  className="flex-1 bg-red-50 hover:bg-red-100 text-red-700 hover:text-red-800 border-red-200 hover:border-red-300 shadow-sm hover:shadow-md transition-all duration-200"
                  size="lg"
                >
                  <span className="material-icons mr-2 text-red-500">logout</span>
                  {t('auth.signOut')}
                </Button>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>

      {/* Anonymous Footer */}
      <AnonymousFooter />
    </div>
  );
};

export { SignOut };
